import { getStorageItem } from '@helpers/localStorage';
import { LocalStorageKeysEnum } from '@enums/localStorageKeys.enum';
import { httpClient } from '@okta/axiosInstance';
import api from '@configs/urls/api';

export const deleteNotificationToken = async (): Promise<void> => {
  const oktaData: any | undefined = getStorageItem(LocalStorageKeysEnum.OKTA_DATA);
  const firebaseDeviceToken: Record<string, string> | undefined = getStorageItem(LocalStorageKeysEnum.PUSH_NOTIFICATION_TOKEN);

  if (!oktaData?.body?.token) return;
  if (!firebaseDeviceToken) return;
  try {
    await httpClient.delete({
      url: api.deleteFireBaseToken,
      config: {
        data: {
          firebaseDeviceToken: firebaseDeviceToken[LocalStorageKeysEnum.PUSH_NOTIFICATION_TOKEN],

        },
      },
    });
  } catch {
  }
};
